import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FirestoreReference, Season } from "src/app/Classes/schema"
import { AnwService } from 'src/app/Services/ANW/anw.service';

@Component({
  selector: 'app-seasonsList',
  templateUrl: './seasons.component.html',
  styleUrls: ['./seasons.component.css']
})
export class SeasonsListComponent implements OnInit, OnDestroy {

  seasons: FirestoreReference<Season>[];
  seasons$: Subscription;
  constructor(private anw: AnwService) {
  }

  ngOnInit() {
    this.seasons = this.anw.initSeasons();
    this.seasons$ = this.anw.getSeasons().subscribe(refs =>{
      this.seasons = refs;
    })
  }

  ngOnDestroy(){
    this.seasons$.unsubscribe();
  }
}
